/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes { 
  GET_ROUTE_LINES = '[Ride] Get Route Lines',
  GET_ROUTE_LINES_SUCCESS = '[Ride] Get Route Lines Success',
  GET_BUS_STOPS = '[Ride] Get Bus Stops',
  GET_BUS_STOPS_SUCCESS = '[Ride] Get Bus Stops Success',
  GET_BUS_STOPS_FAILED = '[Ride] Get Bus Stops Failed',
  GET_BUS_ACTIVITY = '[Ride] Get Bus Activity',
  GET_BUS_ACTIVITY_SUCCESS = '[Ride] Get Bus Activity Success',
  GET_BUS_ACTIVITY_FAILED = '[Ride] Get Bus Activity Failed',
  GET_RIDE_HISTORY = '[Ride] Get Ride History',
  GET_RIDE_HISTORY_SUCCESS= '[Ride] Get Ride History Success',
}

export const getRouteLines = createAction(
  ActionTypes.GET_ROUTE_LINES,
  props<{ data: any }>()
);

export const getRouteLinesSuccess = createAction(
  ActionTypes.GET_ROUTE_LINES_SUCCESS,
  props<{ data: any }>()
);

export const getBusStops = createAction(
  ActionTypes.GET_BUS_STOPS,
  props<{ data: any }>()
);

export const getBustStopsSuccess = createAction(
  ActionTypes.GET_BUS_STOPS_SUCCESS,
  props<{ data: any }>()
);

export const getBustStopsFailed = createAction(
  ActionTypes.GET_BUS_STOPS_FAILED,
  props<{ data: any }>()
);

export const getBusActivity = createAction(
  ActionTypes.GET_BUS_ACTIVITY,
  props<{ data: any, busInfo: any, routeInfo: any }>()
);

export const getBusActivitySuccess = createAction(
  ActionTypes.GET_BUS_ACTIVITY_SUCCESS,
  props<{ data: any, busInfo: any, routeCoordinates: any }>()
);

export const getBusActivityFailed = createAction(
  ActionTypes.GET_BUS_ACTIVITY_FAILED,
  props<{ data: any }>()
);

export const getRideHistory = createAction(
  ActionTypes.GET_RIDE_HISTORY,
  props<{ data: any }>()
);

export const getRideHistorySuccess = createAction(
  ActionTypes.GET_RIDE_HISTORY_SUCCESS,
  props<{ data: any }>()
);